var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "el-core__header menu-header",
      class: { _open: _vm.isOpen, "_drawer-open": _vm.drawerOpen },
    },
    [
      _c("app-core-header-left", {
        attrs: {
          merchant: _vm.profile.merchant,
          account: _vm.profile.merchant.account,
          companyDocument: _vm.companyDocument,
          isOpen: _vm.isOpen,
        },
        on: { appMenuClicked: _vm.toggleAppMenu },
      }),
      _c("app-core-header-right", {
        attrs: {
          merchant: _vm.profile.merchant,
          account: _vm.profile.merchant.account,
          profile: _vm.profile.user,
          isOpen: _vm.drawerOpen,
        },
        on: {
          openOnboarding: _vm.openOnboarding,
          drawerMenuClicked: _vm.toggleDrawerMenu,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }